import { Breadcrumbs, Link, Typography } from '@mui/material';
import type { BreadcrumbItem } from '../../utils/uxNavigation';

type BreadcrumbTrailProps = {
  items: BreadcrumbItem[];
  onNavigate?: (item: BreadcrumbItem) => void;
  ariaLabel?: string;
};

export function BreadcrumbTrail({ items, onNavigate, ariaLabel = 'Breadcrumb' }: BreadcrumbTrailProps) {
  if (items.length === 0) return null;

  return (
    <Breadcrumbs aria-label={ariaLabel} sx={{ mb: 1 }}>
      {items.map((item) => (
        item.current ? (
          <Typography key={item.label} color="text.primary" fontWeight={700}>
            {item.label}
          </Typography>
        ) : (
          <Link
            key={`${item.label}:${item.path || ''}`}
            component="button"
            type="button"
            underline="hover"
            color="inherit"
            onClick={() => onNavigate?.(item)}
            sx={{ cursor: onNavigate ? 'pointer' : 'default', font: 'inherit' }}
          >
            {item.label}
          </Link>
        )
      ))}
    </Breadcrumbs>
  );
}

